import { useEffect, useRef } from "react";
import $ from "jquery";
import "summernote/dist/summernote-lite.css";
import "summernote/dist/summernote-lite.js";

// Same Summernote editor, toolbar and HTML output as nail-view-server's blog editor.
export default function CustomRichText({ props }) {
  const editorRef = useRef(null);

  useEffect(() => {
    const $editor = $(editorRef.current);
    props.register(props.name, {
      validate: (value) =>
        !props.isRequired ||
        Boolean(
          (value || "").replace(/<[^>]*>/g, "").replace(/&nbsp;/gi, " ").trim() ||
          /<img\b/i.test(value || "")
        ) ||
        `${props.label} là bắt buộc !`,
    });

    $editor.summernote({
      height: 200,
      placeholder: props.placeholder || "Nội dung",
      toolbar: [
        ["style", ["style"]],
        ["font", ["bold", "italic", "underline", "clear"]],
        ["color", ["color"]],
        ["para", ["ul", "ol", "paragraph"]],
        ["table", ["table"]],
        ["insert", ["link", "picture"]],
        ["view", ["fullscreen", "codeview", "help"]],
      ],
      callbacks: {
        onChange: (html) => {
          props.setValue(props.name, html, { shouldValidate: true, shouldDirty: true });
        },
      },
    });
    const initialHtml = props.defaultValue || "";
    $editor.summernote("code", initialHtml);
    props.setValue(props.name, initialHtml, { shouldValidate: false });
    return () => {
      $editor.summernote("destroy");
    };
    // A detail form mounts only after data is available; remount when switching records.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="w-full">
      <textarea ref={editorRef} />
      <p className="text-sm mt-1 min-h-[20px] text-red-500">
        {props.errors?.[props.name]?.message || "\u00A0"}
      </p>
    </div>
  );
}
